import { Context } from "@nuxt/types";

import Api from "@/utils/api";
import debounce from "@/utils/debounce";

interface GetParams {
  ltkIds?: string[];
  limit?: number;
  beforeDatetime?: string;
}

const DEFAULT_LIKE_LIMIT = 30;

export default class LikesApi extends Api {
  readonly url = "/v2/likes/";

  constructor($axios: Context["$axios"]) {
    super("contentFavoritesService", $axios);
  }

  async get({ ltkIds, limit = DEFAULT_LIKE_LIMIT, beforeDatetime }: GetParams) {
    return await this.request<ManyLikesResponse>({
      method: "GET",
      params: {
        ltk_ids: ltkIds,
        limit,
        before_datetime: beforeDatetime,
        link_types: ["LTK_WEB"],
      },
    });
  }

  async post(ltkId: string) {
    return await this.request<OneLikeResponse>({
      method: "POST",
      data: {
        like_type: "CLICK",
        network: "LTK",
        ltk_id: ltkId,
      },
    });
  }

  async delete({ ltkIds }: { ltkIds: string[] }) {
    return await this.request<void>({
      method: "DELETE",
      params: {
        ltk_ids: ltkIds,
      },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: 10 })
  async getOne(...ltkIds: string[]) {
    return await this.get({ ltkIds });
  }

  @debounce({ timeout: 50, aggregate: true, batch: 10 })
  async deleteOne(...ltkIds: string[]) {
    return await this.delete({ ltkIds });
  }
}
